export default [
  {
    path: '/dash/account/info',
    name: 'Info',
    component: () => import('@/modules/userInfo/pages/Account.vue'),
    meta: {
      authRequired: true,
      pageTitle: 'Account',
      breadcrumb: [
        {
          text: 'Account',
          active: true,
        },
      ],
    },
  },
  {
    path: '/dash/account/option',
    name: 'Option',
    component: () => import('@/modules/userInfo/pages/Account.vue'),
    meta: {
      authRequired: true,
      pageTitle: 'Account',
      breadcrumb: [
        {
          text: 'Account',
          active: true,
        },
      ],
    },
  },
  {
    path: '/dash/account/change',
    name: 'Change',
    component: () => import('@/modules/userInfo/pages/Account.vue'),
    meta: {
      authRequired: true,
      pageTitle: 'Change',
      breadcrumb: [
        {
          text: 'Change Email or Password',
          active: true,
        },
      ],
    },
  },
];
